import {styles} from "./header-helpers";
import {Box, Divider, IconButton, ListSubheader, Menu, MenuItem} from "@mui/material";
import CloseIcon from "../../../../assets/images/svgs/close.svg";
import * as React from "react";
import {useNavigate} from "react-router-dom";

type ProfileMenuProps = {
    anchorEl: HTMLElement | null;
    openMenu: boolean;
    onCloseMenu: () => void;
    handleLogoutMenu: () => void;
    onClickFaq: () => void;
};


export const ProfileMenu = (props: ProfileMenuProps) => {
const {anchorEl,  openMenu, onCloseMenu, handleLogoutMenu, onClickFaq} = props
    const navigate = useNavigate()
    return (

        <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={openMenu}
            onClose={onCloseMenu}
            onClick={onCloseMenu}
            slotProps={styles.profile.slotProps}
            transformOrigin={{horizontal: 'right', vertical: 'top'}}
            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}>
            <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
                <ListSubheader sx={styles.subHeaderText}>My Account</ListSubheader>
                <IconButton
                    edge="start"
                    color="inherit"
                    sx={styles.profile.closeProfileButton}
                    onClick={onCloseMenu}
                    aria-label="close">
                    <img src={CloseIcon} alt="close-icon"/>
                </IconButton>
            </Box>
            <MenuItem sx={[styles.menuItemText, {mb: "20px"}]} onClick={() => navigate("/profile")}>
                Profile
            </MenuItem>
            <Divider/>
            <ListSubheader sx={[styles.subHeaderText, {mt: "24px"}]}>Support</ListSubheader>
            <MenuItem sx={styles.menuItemText} onClick={() => navigate("/contact-us")}>
                Contact Us
            </MenuItem>
            <MenuItem sx={[styles.menuItemText, {mb: "20px"}]} onClick={onClickFaq}>
                FAQs
            </MenuItem>
            <Divider/>
            <MenuItem sx={[styles.subHeaderText, {mt: "24px", color: "#757575", fontWeight: 400}]}
                      onClick={handleLogoutMenu}>
                Log Out
            </MenuItem>
        </Menu>
    )
}